import axios from "axios";

const axiosInstance = axios.create({
  baseURL: `https://api.sherents.in`,
  /*https://api.socialjusticejamaica.com*/
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("sheToken");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // Detect if payload is FormData
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("sheToken");
      // window.location.replace("/");
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
